import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const navItems = [
  { path: "/dashboard", label: "Home", icon: HomeIcon },
  { path: "/attendance", label: "Absensi", icon: ClockIcon },
  { path: "/attendance/history", label: "Riwayat", icon: HistoryIcon },
  { path: "/leave", label: "Cuti", icon: CalendarIcon },
  { path: "/profile", label: "Profil", icon: UserIcon },
];

export default function BottomNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const getActive = (path, label) => {
    if (label === "Absensi") return pathname === path;
    return pathname === path || pathname.startsWith(path + "/");
  };

  return (
    <nav className="fixed bottom-0 left-1/2 z-40 w-full max-w-[430px] -translate-x-1/2 px-5 pb-4">
      <div className="relative overflow-hidden rounded-2xl border border-white bg-white/88 px-2.5 py-2 shadow-[0_16px_36px_rgba(148,54,54,0.14)] backdrop-blur-xl">
        <div className="pointer-events-none absolute inset-x-0 top-0 h-8 bg-gradient-to-b from-white to-transparent" />
        <div className="relative grid grid-cols-5 items-center gap-1">
          {navItems.map(({ path, label, icon: Icon }) => {
            const active = getActive(path, label);
            return (
              <button
                key={path}
                onClick={() => navigate(path)}
                className={`flex h-[54px] flex-col items-center justify-center gap-1 rounded-xl transition-all active:scale-95 ${
                  active
                    ? "bg-primary text-white shadow-[0_8px_18px_rgba(198,40,40,0.22)]"
                    : "text-gray-500 hover:bg-red-50 hover:text-primary"
                }`}
              >
                <Icon />
                <span className="text-[9px] font-black leading-none tracking-tight">{label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
}

function HomeIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 10.5 12 3l9 7.5V20a1 1 0 0 1-1 1h-5v-7H9v7H4a1 1 0 0 1-1-1v-9.5Z" />
    </svg>
  );
}

function ClockIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </svg>
  );
}

function HistoryIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 3v5h5" />
      <path d="M3.1 13a9 9 0 1 0 2.3-7.1L3 8" />
      <path d="M12 7v5l3 2" />
    </svg>
  );
}

function CalendarIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="17" rx="2" />
      <path d="M16 2v4" />
      <path d="M8 2v4" />
      <path d="M3 10h18" />
    </svg>
  );
}

function UserIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  );
}